export default __webpack_public_path__ + "static/media/addIcon.11524771.svg";